import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './Solutions.css';
import { useLanguage } from '../../context/LanguageContext';

// Import SVG icons
import chessIcon from '../../images/icons/NewIcons/solutions/1-chess.svg';
import devIcon from '../../images/icons/NewIcons/solutions/2-dev.svg';
import robotIcon from '../../images/icons/NewIcons/solutions/3-robot.svg';
import groupIcon from '../../images/icons/NewIcons/solutions/4-group.svg';

const Solutions: React.FC = () => {
  const { t } = useLanguage();

  const solutions = [
    {
      title: t('about.solutions.strategy.title'),
      description: t('about.solutions.strategy.description'),
      icon: chessIcon,
    },
    {
      title: t('about.solutions.development.title'),
      description: t('about.solutions.development.description'),
      icon: devIcon,
    },
    {
      title: t('about.solutions.automation.title'),
      description: t('about.solutions.automation.description'),
      icon: robotIcon,
    },
    {
      title: t('about.solutions.training.title'),
      description: t('about.solutions.training.description'),
      icon: groupIcon,
    },
  ];

  return (
    <section className="solutions-section-negocio">
      <Container>
        <div className="solutions-header">
          <h2 className="section-title">{t('about.solutions.title')}</h2>
        </div>

        <Row className="solutions-cards">
          {solutions.map((solution, idx) => {
            return (
              <Col md={6} lg={3} xs={12} key={idx} className="solution-col">
                <div className="solution-card-negocio">
                  <div className="solution-icon-container">
                    <img src={solution.icon} alt={solution.title} className="solution-svg-icon" />
                  </div>
                  <h3 className="solution-title">{solution.title}</h3>
                  <p className="solution-description">{solution.description}</p>
                </div>
              </Col>
            );
          })}
        </Row>
      </Container>
    </section>
  );
};

export default Solutions;
